export default {"src":"/_next/static/media/yard-area.d37d7cdc.svg","height":24,"width":26,"blurWidth":0,"blurHeight":0};